var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "back-to-top",
      class: { hide: _vm.isHidden },
      attrs: { id: "back-to-top" }
    },
    [
      _c(
        "button",
        {
          ref: "backToTopBtn",
          staticClass: "back-to-top__btn",
          attrs: { type: "button" },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.scrollUp.apply(null, arguments)
            }
          }
        },
        [
          _c("span", { staticClass: "back-to-top__text u-vh" }, [
            _vm._v("\n      " + _vm._s(_vm.gettext("Back to top")) + "\n    ")
          ])
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dcbb124a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcbb124a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/BackToTop.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-dcbb124a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./js/BackToTop.vue
// module chunks = 0